import { useCallback, useEffect, useState } from "react";
import { Undo2 } from "lucide-react";
import { toast } from "sonner";
import { readJson } from "@/hooks/admin/adminApi";

export const undoToast = (authFetch, message, data, onUndone) => {
  if (!data?.undo_id) { toast.success(message); return; }
  toast.success(message, {
    duration: 12000,
    action: {
      label: "Undo",
      onClick: async () => {
        try {
          const res = await authFetch(`/admin/undo/${data.undo_id}`, { method: "POST" });
          const d = await readJson(res);
          if (!res.ok) throw new Error(d?.detail || "Undo failed");
          toast.success(`Undone: ${d.label}`);
          onUndone?.();
        } catch (err) {
          toast.error(err.message || "Undo failed");
        }
      },
    },
  });
};

export const UndoButton = ({ authFetch, onUndone, refreshKey, testId = "undo-last-btn" }) => {
  const [last, setLast] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    try {
      const res = await authFetch("/admin/undo");
      const d = await readJson(res);
      setLast(res.ok ? d.items?.[0] || null : null);
    } catch { setLast(null); }
  }, [authFetch]);
  useEffect(() => { load(); }, [load, refreshKey]);
  const undo = async () => {
    if (!last || !window.confirm(`Undo "${last.label}"? This restores the records exactly as they were before that action.`)) return;
    setBusy(true);
    try {
      const res = await authFetch(`/admin/undo/${last.id}`, { method: "POST" });
      const d = await readJson(res);
      if (!res.ok) throw new Error(d?.detail || "Undo failed");
      toast.success(`Undone: ${d.label}`);
      await load();
      onUndone?.();
    } catch (err) {
      toast.error(err.message || "Undo failed");
    } finally { setBusy(false); }
  };
  return (
    <button type="button" data-testid={testId} onClick={undo} disabled={!last || busy} title={last ? `Undo: ${last.label}` : "Nothing to undo"} className="inline-flex items-center gap-1.5 rounded-full border border-border bg-white px-4 py-2 text-xs hover:bg-muted transition-colors disabled:opacity-50 max-w-[320px]">
      <Undo2 size={13} /> <span className="truncate">{last ? `Undo: ${last.label}` : "Nothing to undo"}</span>
    </button>
  );
};
